import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrl: './progress-dialog.component.css'
})

export class ProgressDialogComponent {
   // Déclare la propriété message
   message: string;
   progress: number; // Définir ici

   constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string, progress: number })  {
     // Assigne la valeur de message depuis les données injectées
     this.message = data.message || 'Chargement...'; // Valeur par défaut si aucune donnée n'est fournie
     this.progress = data.progress || 0; // Initialiser la valeur par défaut si non fournie
   }
}
